/**
 * @link https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 */

let passiveSupported = false;
try {
  const options = {
    get passive() {
      passiveSupported = true;
      return false;
    },
  };
  window.addEventListener("test", null, options);
} catch (err) {
  /* eslint-disable-line no-empty */
}

const defaults = {
  useCapture: false,
  passive: true,
  once: false,
};

export default (options = {}) => {
  const ret = {
    ...defaults,
    ...options,
  };
  return passiveSupported ? ret : ret.useCapture;
};
